import { withTranslation } from "react-i18next";
import WithRouter from "../../../../components/Common/WithRouter";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { confirmPopup, ConfirmPopup } from 'primereact/confirmpopup';
import StateLessGrid from "../../../../components/Shared/StateLessGrid";
import QuickCopyDropdown from "../../../../components/Shared/QuickCopyDropdown";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik, FormikProps } from "formik";
import { InputField } from "../../../../components/Shared/InputField";
import { find, get, includes, isEmpty, map, some, split } from "lodash";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
    ColumnLoadNumber,
    ColumnRenderActualLoadingAt,
    ColumnRenderActualUnloadingAt,
    ColumnRenderDeliveredAt,
    ColumnRenderForBrandModel,
    ColumnRenderForClient, ColumnRenderForDriver, ColumnRenderForInvoiceNumber,
    ColumnRenderForLegalEntity, ColumnRenderForLocation, ColumnRenderForFromLocation, ColumnRenderForToLocation, ColumnRenderForQty, ColumnRenderForTransportVehicle,
    ColumnRenderForVin, ColumnRenderInTransitAt, ColumnRenderInvoicedAt,
    ColumnRenderStatus, getColor
} from "./Column";
import { customSplitter, getLastUpdate, utcDateToLocalDate } from "../../../../utils/Helper";
import Tooltip from "../../../../components/Common/Display/Tooltip";
import { request } from "../../../../utils/Request";
import HasAccess from "../../../../utils/HasAccess";
import SpotLoadStatusUpdate from "./AlpSpotLoad/SpotLoadStatusUpdate";
import AlpSpotLoadAccept from "./AlpSpotLoad/AlpSpotLoadAccept";
import AlpSpotLoadUpdate from "./AlpSpotLoad/AlpSpotLoadUpdate";
import AlpSpotLoadReject from "./AlpSpotLoad/AlpSpotLoadReject";
import AlpSpotLoadReset from "./AlpSpotLoad/AlpSpotLoadReset";
import AlpSpotLoadInTransit from "./AlpSpotLoad/AlpSpotLoadInTransit";
import AlpSpotLoadUnloadRequest from "./AlpSpotLoad/AlpSpotLoadUnloadRequest";
import { css, cx } from '@emotion/css';
import AlpSpotLoadUpdatePrice from "../../alpSpotLoads/partials/AlpSpotLoadUpdatePrice";
import { ButtonGroup } from "primereact/buttongroup";
import LoadExcel from "./LoadExcel";
import ShowInvoiceableLoad from "./ShowInvoiceableLoad";
import AllInvoiceableList from "./AllInvoiceableList";
import LoadPrePayment from "./LoadPrePayment";
import AlpInboundLoadAccept from "./AlpInboundLoad/AlpInboundLoadAccept";
import AlpInboundLoadReject from "./AlpInboundLoad/AlpInboundLoadReject";
import AlpInboundLoadReset from "./AlpInboundLoad/AlpInboundLoadReset";
import AlpInboundLoadTransportOrder from "./AlpInboundLoad/AlpInboundLoadTransportOrder";
import AlpInboundLoadUpdate from "./AlpInboundLoad/AlpInboundLoadUpdate";
import AlpInboundLoadInTransit from "./AlpInboundLoad/AlpInboundLoadInTransit";
import AlpInboundLoadUnloadRequest from "./AlpInboundLoad/AlpInboundLoadUnloadRequest";
import AlpInboundLoadConfirmTransportOrder from "./AlpInboundLoad/AlpInboundLoadConfirmTransportOrder";
import AlpInboundLoadCCConfirmTransportOrder from "./AlpInboundLoad/AlpInboundLoadCCConfirmTransportOrder";
import AlpInboundLoadCCDeclineTransportOrder from "./AlpInboundLoad/AlpInboundLoadCCDeclineTransportOrder";
import AlpInboundLoadUpdatePrice from "../../alpInboundLoads/partials/AlpInboundLoadUpdatePrice";
import AlpOutboundLoadReject from "./AlpOutboundLoad/AlpOutboundLoadReject";
import AlpOutboundLoadAccept from "./AlpOutboundLoad/AlpOutboundLoadAccept";
import AlpOutboundLoadReset from "./AlpOutboundLoad/AlpOutboundLoadReset";
import AlpOutboundLoadInTransit from "./AlpOutboundLoad/AlpOutboundLoadInTransit";
import AlpOutboundLoadUpdate from "./AlpOutboundLoad/AlpOutboundLoadUpdate";
import AlpOutboundLoadUnloadRequest from "./AlpOutboundLoad/AlpOutboundLoadUnloadRequest";
import AlpOutboundLoadUpdatePrice from "../../alpOutboundLoads/partials/AlpOutboundLoadUpdatePrice";
import AlpOutboundLoadGroupAccept from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupAccept";
import AlpOutboundLoadGroupReset from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupReset";
import AlpOutboundLoadGroupInTransit from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupInTransit";
import AlpOutboundLoadGroupUpdate from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupUpdate";
import AlpOutboundLoadGroupUnloadRequest from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupUnloadRequest";
import AlpOutboundLoadGroupGenerateCmr from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupGenerateCmr";
import AlpOutboundLoadGroupDetach from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupDetach";
import AlpOutboundLoadGroupAddLoad from "./AlpOutboundLoadGroup/AlpOutboundLoadGroupAddLoad";
import AlpReexportLoadAccept from "./AlpReexportLoad/AlpReexportLoadAccept";
import AlpReexportLoadReject from "./AlpReexportLoad/AlpReexportLoadReject";
import AlpReexportLoadUpdate from "./AlpReexportLoad/AlpReexportLoadUpdate";
import AlpReexportLoadInTransit from "./AlpReexportLoad/AlpReexportLoadInTransit";
import AlpReexportLoadUnloadRequest from "./AlpReexportLoad/AlpReexportLoadUnloadRequest";
import LoadFilter from "./LoadFilter";
import AlpFreezeStatusNotice from "./AlpFreezeStatusNotice";
import LoadComments from "./LoadComments";
import LoadListDetailPanel from "./LoadListDetailPanel";

const TAB_PARAM = 'tab';
const DETAIL_TYPE_PARAM = 'detailType';
const DETAIL_LOAD_NUMBER_PARAM = 'detailLoadNumber';

function getTitleLoadNumber(raw: any) {
    if ( !raw ) {
        return '';
    }

    const firstPart = String(raw).split('||')[0];
    return firstPart.split('___')[0].trim();
}

function getLoadTypeLabel(loadType: any, t: any) {
    if ( loadType === 'SpotLoad' ) {
        return t('spot load');
    }
    if ( loadType === 'AlpSpotLoad' ) {
        return t('EF') + ' ' + t('spot load');
    }
    if ( loadType === 'AlpInboundLoad' ) {
        return t('EF') + ' ' + t('inbound load');
    }
    if ( loadType === 'AlpOutboundLoad' ) {
        return t('EF') + ' ' + t('outbound load');
    }
    if ( loadType === 'AlpReexportLoad' ) {
        return t('EF') + ' ' + t('self pickup load');
    }
    if ( loadType === 'AlpOutboundLoadGroup' ) {
        return t('outbound load groups');
    }

    return t('loads');
}

function getDetailPageTitle(loadType: any, loadNumber: any, t: any) {
    const label = getLoadTypeLabel(loadType, t);
    const number = getTitleLoadNumber(loadNumber);

    if ( number ) {
        return label + ' #' + number;
    }

    return label;
}

function parseTab(rawTab: any) {
    if ( rawTab === 'outbound' ) {
        return 'outbound';
    }
    if ( rawTab === 'reexport' ) {
        return 'reexport';
    }
    return 'inbound';
}

function loadTypesForTab(tab: any) {
    if ( tab === 'outbound' ) {
        return ['OutboundLoad'];
    }
    if ( tab === 'reexport' ) {
        return ['ReexportLoad'];
    }
    return ['InboundLoad'];
}

function getFiltersObject(filters: any) {
    if ( !filters || typeof filters !== 'object' || Array.isArray(filters) ) {
        return {};
    }
    return filters;
}

const LoadList = (props: any) => {
    const { t, moduleState, dropdowns, toastify } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [spotLoadItemToBeUpdate, setSpotLoadItemToBeUpdate] = useState<any>(null);
    const [filterPanel, setFilterPanel] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const [operation, setOperation] = useState<any>(searchParams.get('operation') ?? null);
    const [operationId, setOperationId] = useState<any>(searchParams.get('operationId') ?? null);
    const [detailLoadType, setDetailLoadType] = useState<any>(searchParams.get(DETAIL_TYPE_PARAM) ?? null);
    const [detailLoadNumber, setDetailLoadNumber] = useState<any>(searchParams.get(DETAIL_LOAD_NUMBER_PARAM) ?? null);
    const [total, setTotal] = useState(0);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const tableRef: any = useRef();
    const [excelPanel, setExcelPanel] = useState<boolean>(false);
    const [invoiceableLoad, setInvoiceableLoad] = useState<string|null>(null);
    const [bulkInvoiceVisibility, setBulkInvoiceVisibility] = useState(false);
    const [paymentVisibility, setPaymentVisibility] = useState({});
    const activeTab = parseTab(searchParams.get(TAB_PARAM) || moduleState.tab);
    const activeIndex = activeTab === 'outbound' ? 1 : (activeTab === 'reexport' ? 2 : 0);

    const goToSpotLoadModule = (path: any) => {
        props.router.navigate(path);
    };

    const openDetail = (row: any) => {
        const sp = new URLSearchParams(location.search);
        sp.set('operation', 'detail');
        sp.set('operationId', row.id);
        sp.set(DETAIL_TYPE_PARAM, row.type);
        sp.set(DETAIL_LOAD_NUMBER_PARAM, row.load_number || '');

        navigate({
            pathname: location.pathname,
            search: sp.toString(),
        }, { replace: true });

        setOperation('detail');
        setOperationId(row.id);
        setDetailLoadType(row.type);
        setDetailLoadNumber(row.load_number || '');
    };

    const getRowProviderSlug = (row: any) => {
        return row?.provider_slug
            ?? row?.providerSlug
            ?? row?.provider?.slug
            ?? row?.source_type
            ?? null;
    };

    const onDelete = async (payloads: any): Promise<void> => {
        try {
            await request({
                url: `suppliers/spot/loads/${ payloads.id }`,
                method: 'DELETE',
                data: {
                    _method: 'DELETE',
                    ...payloads
                }
            });

            toastify(t("record deleted", { item: t('spot load') }), "error");

            if ( tableRef.current ) {
                tableRef.current.onRefresh();
            }
        } catch (e: any) {
            toastify(t("server error"), "error");
        }
    };

    const onRaiseInvoiceClick = async (payloads: any): Promise<void> => {
        setBulkInvoiceVisibility(false);
        setInvoiceableLoad(payloads);
    };

    const onInvoicePaymentClick = async (payloads: any): Promise<void> => {
        setPaymentVisibility({
            id: payloads.id,
            type: payloads.type,
            price_type: payloads.price_type,
            load_number: payloads.load_number,
        });
    };

    const verifyDeliveredOrInTransitStatus = (inputString: any, statuses: string[]) => {
        const parts = split(inputString, '||');

        return some(parts, (part: string) => {
            const [, status] = split(part, '___');
            return statuses.includes(status);
        });
    };

    const SpotLoadActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;

        return (
            <>
                <HasAccess hasAnyAccess={ ['spotloadsupdate'] }>
                    <Tooltip tooltip={ t('edit item') } position={ "top" }>
                        <a
                            className={ "cursor-pointer ms-1 text-yellow-500" }
                            onClick={ () => {
                                goToSpotLoadModule(`/spot/loads?back_to=loads&operation=edit&operationId=${ _row.id }`);
                            } }>
                            <i className="fas fa-edit" />
                        </a>
                    </Tooltip>
                </HasAccess>

                {
                    ( _row.has_delivered_items <= 0 )
                    && // _row.has_invoiced_items <= 0 && allow invoiced item to get delete
                    <HasAccess hasAnyAccess={ ['spotloadsdestroy'] }>
                        <Tooltip tooltip={ t('delete item') } position={"top"}>
                            <a
                              title={ t('delete item') }
                              className={ "cursor-pointer ms-1 text-red-500" }
                              onClick={ (event: any) => confirmPopup({
                                  target: event.currentTarget,
                                  message: t('do you want to delete this record?'),
                                  icon: 'pi pi-info-circle',
                                  // @ts-ignorer
                                  defaultFocus: 'reject',
                                  acceptClassName: 'p-button-danger',
                                  accept: () => onDelete(_row),
                                  reject: () => {
                                  },
                              }) }>
                                <i className="fas fa-trash-alt" />
                            </a>
                        </Tooltip>
                    </HasAccess>
                }

                <Tooltip tooltip={ t('detail of item') } position={"top"}>
                    <a
                        className={ "cursor-pointer ms-1" }
                        onClick={ () => {
                            openDetail(_row);
                        } }>
                        <i className="fas fa-eye" />
                    </a>
                </Tooltip>

                  <HasAccess hasAnyAccess={ ['invoicesstore'] }>
                      {
                          verifyDeliveredOrInTransitStatus(_row.item_status, ['in-transit', 'delivered', 'archived']) &&
                          <Tooltip tooltip={ t('raise invoice') } position={ "top" }>
                              <a
                                className={ "cursor-pointer ms-1 text-red-300" }
                                onClick={ () => onRaiseInvoiceClick(_row) }>
                                  <i className="fas fa-exclamation-triangle" />
                              </a>
                          </Tooltip>
                      }

                      <Tooltip tooltip={ t('add payments') } position={ "top" }>
                          <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => onInvoicePaymentClick(_row) }>
                              <i className="fas fa-credit-card" />
                          </a>
                      </Tooltip>
                  </HasAccess>
            </>
        );
    };

    // ALP SPOT LOAD States and Methods
    const [resetAlpSpotLoadId, setResetAlpSpotLoadId] = useState(null);
    const [rejectAlpSpotLoadId, setRejectAlpSpotLoadId] = useState(null);
    const [acceptAlpSpotLoadId, setAcceptAlpSpotLoadId] = useState(null);
    const [editAlpSpotLoadId, setEditAlpSpotLoadId] = useState(null);
    const [inTransitAlpSpotLoadId, setInTransitAlpSpotLoadId] = useState(null);
    const [unloadRequestAlpSpotLoadId, setUnloadRequestAlpSpotLoadId] = useState(null);
    const [loadId, setLoadId] = useState<any>(null);
    const [commentLoad, setCommentLoad] = useState<any>(null);
    const [alpLoadProviderSlug, setAlpLoadProviderSlug] = useState<any>(null);
    const [syncOnInbound, setSyncOnInbound] = useState(false);
    const [syncOnOutbound, setSyncOnOutbound] = useState(false);
    const [syncOnReexport, setSyncOnReexport] = useState(false);
    const [syncOnSpot, setSyncOnSpot] = useState(false);
    const [clickCount, setClickCount] = useState(0);
    const [visibleSpecialAction, setVisibleSpecialAction] = useState(false);
    const [disableSpecialActionInbound, setDisableSpecialActionInbound] = useState(false);
    const [disableSpecialActionOutbound, setDisableSpecialActionOutbound] = useState(false);
    const [disableSpecialActionReexport, setDisableSpecialActionReexport] = useState(false);
    const [disableSpecialActionSpot, setDisableSpecialActionSpot] = useState(false);

    const onResetAlpSpotLoad = (id: any) => setResetAlpSpotLoadId(id);
    const onRejectAlpSpotLoad = (id: any) => setRejectAlpSpotLoadId(id);
    const onAcceptAlpSpotLoad = (id: any) => setAcceptAlpSpotLoadId(id);
    const onEditAlpSpotLoad = (id: any) => setEditAlpSpotLoadId(id);
    const onInTransitAlpSpotLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setInTransitAlpSpotLoadId(row.id);
    };
    const onUnloadRequestAlpSpotLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setUnloadRequestAlpSpotLoadId(row.id);
    };
    const onOpenLoadComments = (row: any) => setCommentLoad(row);

    const onAlpInboundLoadSyncList = async () => {
        setSyncOnInbound(true);
        try {
            const response = await request({
                url: `/suppliers/provider/inbound/loads/sync/list`,
                method: 'POST',
            });

            toastify(t("request received to sync all inbound loads"), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        } finally {
            setSyncOnInbound(false);
            setDisableSpecialActionInbound(true);
        }
    };

    const onAlpOutboundLoadSyncList = async () => {
        setSyncOnOutbound(true);
        try {
            const response = await request({
                url: `/suppliers/provider/outbound/loads/sync/list`,
                method: 'POST',
            });

            toastify(t("request received to sync all outbound loads"), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        } finally {
            setSyncOnOutbound(false);
            setDisableSpecialActionOutbound(true);
        }
    };

    const onAlpReexportLoadSyncList = async () => {
        setSyncOnReexport(true);
        try {
            await request({
                url: `/suppliers/provider/reexport/loads/sync/list`,
                method: 'POST',
            });

            toastify(t("request received to sync all self pickup loads"), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        } finally {
            setSyncOnReexport(false);
            setDisableSpecialActionReexport(true);
        }
    };

    const onAlpSpotLoadSyncList = async () => {
        setSyncOnSpot(true);
        try {
            const response = await request({
                url: `/suppliers/provider/spot/loads/sync/list`,
                method: 'POST',
            });

            toastify(t("request received to sync all spot loads"), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        } finally {
            setSyncOnSpot(false);
            setDisableSpecialActionSpot(true);
        }
    };

    const handleHeaderClick = () => {
        const newCount = clickCount + 1;
        setClickCount(newCount);

        if ( newCount >= 5 && !visibleSpecialAction ) {
            setVisibleSpecialAction(true);
        }
    };

    const onAlpSpotLoadSync = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/alp/spot/loads/${ id }/sync`,
                method: 'POST',
            });

            toastify(t("record updated", { item: t('alp spot load') + ' ' + t('spot load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        }
    };

    const AlpSpotLoadActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;

        return (
            <>
                <HasAccess hasAnyAccess={ ['alpspotloadsupdate'] }>
                    <Tooltip tooltip={ t('sync from alp') }>
                        <a onClick={ () => onAlpSpotLoadSync(_row.id) }
                           className={ "cursor-pointer ms-1" }>
                            <i className="fas fa-sync" />
                        </a>
                    </Tooltip>

                    {
                        includes(['accepted'], _row.status) && isEmpty(_row.reset_at)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reset') }>
                            <a onClick={ () => onResetAlpSpotLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-primary-500" }>
                                <i className="fas fa-redo-alt" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('accept') }>
                            <a onClick={ () => onAcceptAlpSpotLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-blue-500" }>
                                <i className="fas fa-check" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reject') }>
                            <a onClick={ () => onRejectAlpSpotLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-red-500" }>
                                <i className="fas fa-times" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['accepted', 'confirmed'], _row.status)
                        && includes(['n/a', 'approved'], _row.fca_status)
                        && ( isEmpty(_row.edited_at) && isEmpty(_row.reset_at) )
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('edit item') }>
                            <a onClick={ () => onEditAlpSpotLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-yellow-500" }>
                                <i className="fas fa-edit" />
                            </a>
                        </Tooltip>
                    }

                    {
                        (
                            includes(['accepted', 'confirmed', 'updated'], _row.status)
                            && includes(['n/a', 'approved'], _row.fca_status)
                        )
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('in transit') }>
                            <a onClick={ () => onInTransitAlpSpotLoad(_row) }
                               className={ "cursor-pointer ms-1 text-green-500" }>
                                <i className="fas fa-truck-moving" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['in-transit'], _row.status)
                        && ( (
                                !isEmpty(_row.from_supplier_compound) && !isEmpty(_row.gate_out_confirmed_at)
                            ) || (
                                isEmpty(_row.from_supplier_compound) && isEmpty(_row.gate_out_confirmed_at)
                            )
                        )
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('unload request') }>
                            <a onClick={ () => onUnloadRequestAlpSpotLoad(_row) }
                               className={ "cursor-pointer text-green-500 ms-1" }>
                                <i className="fas fa-truck-loading" />
                            </a>
                        </Tooltip>
                    }
                    {
                        ( _row.type == 'AlpSpotLoad' ) &&
                        <Tooltip tooltip={ t('update price') } position={ "left" }>
                            <a
                              className={ "cursor-pointer ms-1 text-primary-500" }
                              onClick={ () => setLoadId(_row.id) }>
                                <i className="fas fa-dollar-sign" />
                            </a>
                        </Tooltip>
                    }

                    <Tooltip tooltip={ t('detail of item') }>
                        <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => {
                                openDetail(_row);
                            } }>
                            <i className="fas fa-eye" />
                        </a>
                    </Tooltip>

                    {
                        includes(['accepted', 'confirmed', 'in-transit', 'unload-requested', 'unloaded', 'delivered', 'archived'], _row.item_status)
                        &&
                        <HasAccess hasAnyAccess={ ['invoicesstore'] }>
                            <Tooltip tooltip={ t('raise invoice') } position={ "top" }>
                                <a
                                    className={ "cursor-pointer ms-1 text-red-300" }
                                    onClick={ () => onRaiseInvoiceClick(_row) }>
                                    <i className="fas fa-exclamation-triangle" />
                                </a>
                            </Tooltip>
                        </HasAccess>
                    }

                  <HasAccess hasAnyAccess={ ['invoicepaymentsstore'] }>
                      <Tooltip tooltip={ t('add payments') } position={ "top" }>
                          <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => onInvoicePaymentClick(_row) }>
                              <i className="fas fa-credit-card" />
                          </a>
                      </Tooltip>
                  </HasAccess>
                </HasAccess>
            </>
        );
    };

    const [resetAlpInboundLoadId, setResetAlpInboundLoadId] = useState(null);
    const [rejectAlpInboundLoadId, setRejectAlpInboundLoadId] = useState(null);
    const [acceptAlpInboundLoadId, setAcceptAlpInboundLoadId] = useState(null);
    const [confirmTransportOrderAlpInboundLoadId, setConfirmTransportOrderAlpInboundLoadId] = useState(null);
    const [editAlpInboundLoadId, setEditAlpInboundLoadId] = useState(null);
    const [inTransitAlpInboundLoadId, setInTransitAlpInboundLoadId] = useState(null);
    const [unloadRequestAlpInboundLoadId, setUnloadRequestAlpInboundLoadId] = useState(null);
    const [inboundLoadProviderSlug, setInboundLoadProviderSlug] = useState<any>(null);
    const [confirmAfterApprovedTransportOrderAlpInboundLoadId, setConfirmAfterApprovedTransportOrderAlpInboundLoadId] = useState(null);
    const [ccConfirmTransportOrderAlpInboundLoadId, setCcConfirmTransportOrderAlpInboundLoadId] = useState(null);
    const [ccDeclineTransportOrderAlpInboundLoadId, setCcDeclineTransportOrderAlpInboundLoadId] = useState(null);
    const [inboundLoadPriceId, setInboundLoadPriceId] = useState<any>(null);
    const [generateCmrAlpInboundLoadId, setGenerateCmrAlpInboundLoadId] = useState<any>(null);

    const onResetAlpInboundLoad = (id: any) => setResetAlpInboundLoadId(id);
    const onRejectAlpInboundLoad = (id: any) => setRejectAlpInboundLoadId(id);
    const onAcceptAlpInboundLoad = (id: any) => setAcceptAlpInboundLoadId(id);
    const onConfirmTransportOrderAlpInboundLoad = (id: any) => setConfirmTransportOrderAlpInboundLoadId(id);
    const onConfirmAfterApprovedTransportOrderAlpInboundLoad = (id: any) => setConfirmAfterApprovedTransportOrderAlpInboundLoadId(id);
    const onEditAlpInboundLoad = (id: any) => setEditAlpInboundLoadId(id);
    const onInTransitAlpInboundLoad = (row: any) => {
        setInboundLoadProviderSlug(getRowProviderSlug(row));
        setInTransitAlpInboundLoadId(row.id);
    };
    const onUnloadRequestAlpInboundLoad = (row: any) => {
        setInboundLoadProviderSlug(getRowProviderSlug(row));
        setUnloadRequestAlpInboundLoadId(row.id);
    };
    const onGenerateCmrAlpInboundLoad = (id: any) => setGenerateCmrAlpInboundLoadId(id);
    const onCcConfirmTransportOrderAlpInboundLoadId = (id: any) => setCcConfirmTransportOrderAlpInboundLoadId(id);
    const onCcDeclineTransportOrderAlpInboundLoadId = (id: any) => setCcDeclineTransportOrderAlpInboundLoadId(id);

    const onAlpInboundLoadSync = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/alp/inbound/loads/${ id }/sync`,
                method: 'POST',
            });

            toastify(t("record updated", { item: t('alp inbound load') + ' ' + t('inbound load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        }
    };

    const AlpInboundLoadActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;

        return (
            <>
                <HasAccess hasAnyAccess={ ['alpinboundloadsupdate'] }>
                    <Tooltip tooltip={ t('sync from alp') }>
                        <a onClick={ () => onAlpInboundLoadSync(_row.id) }
                           className={ "cursor-pointer ms-1" }>
                            <i className="fas fa-sync" />
                        </a>
                    </Tooltip>

                    {
                        includes(['accepted'], _row.status) && isEmpty(_row.reset_at)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reset') }>
                            <a onClick={ () => onResetAlpInboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-primary-500" }>
                                <i className="fas fa-redo-alt" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('accept') }>
                            <a onClick={ () => onAcceptAlpInboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-blue-500" }>
                                <i className="fas fa-check" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reject') }>
                            <a onClick={ () => onRejectAlpInboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-red-500" }>
                                <i className="fas fa-times" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['accepted'], _row.status)
                        && _row.does_manufacturer_approval_required
                        && _row.fca_status == 'approved'
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('transport order') }>
                          <a onClick={ () => onConfirmTransportOrderAlpInboundLoad(_row.id) }
                             className={ "cursor-pointer ms-1" }>
                              <i className="fas fa-check-square" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['confirmed'], _row.status)
                        && _row.does_manufacturer_approval_required
                        && _row.fca_status == 'approved'
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('transport order') }>
                          <a onClick={ () => onConfirmAfterApprovedTransportOrderAlpInboundLoad(_row.id) }
                             className={ "cursor-pointer ms-1 text-green-500" }>
                              <i className="fas fa-check-square" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['ready-to-load'], _row.status)
                        && isEmpty(_row.edited_at)
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('edit load') }>
                          <a onClick={ () => onEditAlpInboundLoad(_row.id) }
                             className={ "cursor-pointer ms-1" }>
                              <i className="fas fa-edit" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['transport-order-pending'], _row.status)
                        && !isEmpty(_row.cc_confirmed_at)
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('confirm transport order') }>
                          <a onClick={ () => onCcConfirmTransportOrderAlpInboundLoadId(_row.id) }
                             className={ "cursor-pointer ms-1 text-green-500" }>
                              <i className="fas fa-check-square" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['transport-order-pending'], _row.status)
                        && !isEmpty(_row.cc_confirmed_at)
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('decline transport order') }>
                          <a onClick={ () => onCcDeclineTransportOrderAlpInboundLoadId(_row.id) }
                             className={ "cursor-pointer ms-1 text-red-500" }>
                              <i className="fas fa-times-circle" />
                          </a>
                      </Tooltip>
                    }

                    {
                        (includes(['ready-to-load'], _row.status)
                        && includes(['n/a', 'approved'], _row.fca_status))
                        && /*@ts-ignore*/
                      <Tooltip tooltip={ t('in transit') }>
                          <a onClick={ () => onInTransitAlpInboundLoad(_row) }
                             className={ "cursor-pointer ms-1 text-green-500" }>
                              <i className="fas fa-truck-moving" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['in-transit'], _row.status)
                        && ( (
                                !isEmpty(_row.from_supplier_compound) && !isEmpty(_row.gate_out_confirmed_at)
                            ) || (
                                isEmpty(_row.from_supplier_compound) && isEmpty(_row.gate_out_confirmed_at)
                            )
                        )
                        &&
                        /*@ts-ignore*/
                      <Tooltip tooltip={ t('unload request') }>
                          <a onClick={ () => onUnloadRequestAlpInboundLoad(_row) }
                             className={ "cursor-pointer text-green-500 ms-1" }>
                              <i className="fas fa-truck-loading" />
                          </a>
                      </Tooltip>
                    }

                    {
                        includes(['in-transit', 'unload-requested'], _row.status)
                        && 
                      <Tooltip tooltip={ t('create cmr') }>
                          <a
                              onClick={ () => onGenerateCmrAlpInboundLoad(_row.id) }
                              className={ "cursor-pointer ms-1 text-primary-500" }
                          >
                              <i className="fas fa-file-signature" />
                          </a>
                      </Tooltip>
                    }

                    {
                        ( _row.type == 'AlpInboundLoad' ) &&
                      <Tooltip tooltip={ t('update price') } position={ "left" }>
                          <a
                            className={ "cursor-pointer ms-1 text-primary-500" }
                            onClick={ () => setInboundLoadPriceId(_row.id) }>
                              <i className="fas fa-dollar-sign" />
                          </a>
                      </Tooltip>
                    }

                    <HasAccess hasAnyAccess={ ['invoicepaymentsstore'] }>
                        <Tooltip tooltip={ t('add payments') } position={ "top" }>
                            <a
                                className={ "cursor-pointer ms-1" }
                                onClick={ () => onInvoicePaymentClick(_row) }>
                                <i className="fas fa-credit-card" />
                            </a>
                        </Tooltip>
                    </HasAccess>

                    {
                        includes(['accepted', 'confirmed', 'in-transit', 'unload-requested', 'unloaded', 'delivered', 'archived'], _row.item_status)
                        &&
                      <HasAccess hasAnyAccess={ ['invoicesstore'] }>
                          <Tooltip tooltip={ t('raise invoice') } position={ "top" }>
                              <a
                                className={ "cursor-pointer ms-1 text-red-300" }
                                onClick={ () => onRaiseInvoiceClick(_row) }>
                                  <i className="fas fa-exclamation-triangle" />
                              </a>
                          </Tooltip>
                      </HasAccess>
                    }

                    <Tooltip tooltip={ t('detail of item') }>
                        <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => {
                                openDetail(_row);
                            } }>
                            <i className="fas fa-eye" />
                        </a>
                    </Tooltip>

                </HasAccess>
            </>
        );
    };

    // start outbound here
    const [rejectAlpOutboundLoadId, setRejectAlpOutboundLoadId] = useState(null);
    const [acceptAlpOutboundLoadId, setAcceptAlpOutboundLoadId] = useState(null);
    const [resetAlpOutboundLoadId, setResetAlpOutboundLoadId] = useState(null);
    const [inTransitAlpOutboundLoadId, setInTransitAlpOutboundLoadId] = useState(null);
    const [editAlpOutboundLoadId, setEditAlpOutboundLoadId] = useState(null);
    const [unloadRequestAlpOutboundLoadId, setUnloadRequestAlpOutboundLoadId] = useState(null);
    const [generateCmrAlpOutboundLoadId, setGenerateCmrAlpOutboundLoadId] = useState<any>(null);
    const [outboundLoadPriceId, setOutboundLoadPriceId] = useState<any>(null);
    const [acceptAlpOutboundLoadGroupId, setAcceptAlpOutboundLoadGroupId] = useState<any>(null);
    const [resetAlpOutboundLoadGroupId, setResetAlpOutboundLoadGroupId] = useState<any>(null);
    const [inTransitAlpOutboundLoadGroupId, setInTransitAlpOutboundLoadGroupId] = useState<any>(null);
    const [editAlpOutboundLoadGroupId, setEditAlpOutboundLoadGroupId] = useState<any>(null);
    const [unloadRequestAlpOutboundLoadGroupId, setUnloadRequestAlpOutboundLoadGroupId] = useState<any>(null);
    const [generateCmrAlpOutboundLoadGroupId, setGenerateCmrAlpOutboundLoadGroupId] = useState<any>(null);
    const [detachAlpOutboundLoadGroupId, setDetachAlpOutboundLoadGroupId] = useState<any>(null);
    const [addLoadAlpOutboundLoadGroupId, setAddLoadAlpOutboundLoadGroupId] = useState<any>(null);
    const [acceptAlpReexportLoadId, setAcceptAlpReexportLoadId] = useState<any>(null);
    const [rejectAlpReexportLoadId, setRejectAlpReexportLoadId] = useState<any>(null);
    const [editAlpReexportLoadId, setEditAlpReexportLoadId] = useState<any>(null);
    const [inTransitAlpReexportLoadId, setInTransitAlpReexportLoadId] = useState<any>(null);
    const [unloadRequestAlpReexportLoadId, setUnloadRequestAlpReexportLoadId] = useState<any>(null);

    const onRejectAlpOutboundLoad = (id: any) => setRejectAlpOutboundLoadId(id);
    const onAcceptAlpOutboundLoad = (id: any) => setAcceptAlpOutboundLoadId(id);
    const onResetAlpOutboundLoad = (id: any) => setResetAlpOutboundLoadId(id);
    const onInTransitAlpOutboundLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setInTransitAlpOutboundLoadId(row.id);
    };
    const onEditAlpOutboundLoad = (id: any) => setEditAlpOutboundLoadId(id);
    const onUnloadRequestAlpOutboundLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setUnloadRequestAlpOutboundLoadId(row.id);
    };
    const onGenerateCmrAlpOutboundLoad = (id: any) => setGenerateCmrAlpOutboundLoadId(id);
    const onAcceptAlpOutboundLoadGroup = (id: any) => setAcceptAlpOutboundLoadGroupId(id);
    const onResetAlpOutboundLoadGroup = (id: any) => setResetAlpOutboundLoadGroupId(id);
    const onInTransitAlpOutboundLoadGroup = (id: any) => setInTransitAlpOutboundLoadGroupId(id);
    const onEditAlpOutboundLoadGroup = (id: any) => setEditAlpOutboundLoadGroupId(id);
    const onUnloadRequestAlpOutboundLoadGroup = (id: any) => setUnloadRequestAlpOutboundLoadGroupId(id);
    const onGenerateCmrAlpOutboundLoadGroup = (id: any) => setGenerateCmrAlpOutboundLoadGroupId(id);
    const onAcceptAlpReexportLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setAcceptAlpReexportLoadId(row.id);
    };
    const onRejectAlpReexportLoad = (id: any) => setRejectAlpReexportLoadId(id);
    const onEditAlpReexportLoad = (id: any) => setEditAlpReexportLoadId(id);
    const onInTransitAlpReexportLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setInTransitAlpReexportLoadId(row.id);
    };
    const onUnloadRequestAlpReexportLoad = (row: any) => {
        setAlpLoadProviderSlug(getRowProviderSlug(row));
        setUnloadRequestAlpReexportLoadId(row.id);
    };

    const onAlpOutboundLoadSync = async (id: string) => {
        try {
            const response = await request({
                url: `/suppliers/alp/outbound/loads/${ id }/sync`,
                method: 'POST',
            });

            toastify(t("record updated", { item: t('alp outbound load') + ' ' + t('outbound load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        }
    };

    const onAlpReexportLoadSync = async (id: string) => {
        try {
            await request({
                url: `/suppliers/alp/reexport/loads/${ id }/sync`,
                method: 'POST',
            });

            toastify(t("record updated", { item: t('self pickup load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        }
    };

    const onAlpOutboundLoadGroupSync = async (groupToken: string) => {
        try {
            await request({
                url: `/suppliers/alp/aviso/outbound/loads/${ groupToken }/sync`,
                method: 'POST',
            });

            toastify(t("record updated", { item: t('alp outbound load') + ' ' + t('outbound load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify(e.data.errors.driver_id.join(", "), "error");
            } else if ( e.statusText ) {
                toastify(e.statusText, "error");
            }
        }
    };

    const onDeleteAlpOutboundLoadGroup = async (groupToken: string) => {
        try {
            const detailResponse = await request({
                url: `/suppliers/provider/aviso/outbound/groups/${ groupToken }`,
            });
            const detailData = detailResponse?.data?.data ?? detailResponse?.data ?? {};
            const loads = Array.isArray(detailData?.alp_outbound_loads) ? detailData.alp_outbound_loads : [];
            const eligibleLoadIds = loads
                .map((load: any) => load?.id)
                .filter((id: any) => !isEmpty(id));

            if ( eligibleLoadIds.length <= 0 ) {
                toastify && toastify(t("action not allowed: 404"), "error");
                return;
            }

            await request({
                method: 'POST',
                url: `/suppliers/alp/aviso/outbound/loads/${ groupToken }/detach`,
                data: {
                    load_ids: eligibleLoadIds,
                    allow_empty_group: true,
                },
            });

            toastify && toastify(t("record deleted", { item: t('outbound load') }), "info");
            refreshTable();
        } catch (e: any) {
            if ( e.status === 422 ) {
                toastify && toastify(t("unprocessable entity"), "error");
            } else if ( e.status === 404 ) {
                toastify && toastify(t("action not allowed: 404"), "error");
            } else {
                toastify && toastify(t("server error"), "error");
            }
        }
    };

    const AlpOutboundLoadActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;

        return (
            <>
                <HasAccess hasAnyAccess={ ['alpoutboundloadsupdate'] }>
                    <Tooltip tooltip={ t('sync from alp') }>
                        <a onClick={ () => onAlpOutboundLoadSync(_row.id) }
                           className={ "cursor-pointer ms-1" }>
                            <i className="fas fa-sync" />
                        </a>
                    </Tooltip>

                    {
                        includes(['accepted'], _row.status) && isEmpty(_row.reset_at) && isEmpty(_row.gate_out_confirmed_at)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reset') }>
                            <a onClick={ () => onResetAlpOutboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-primary-500" }>
                                <i className="fas fa-redo-alt" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('accept') }>
                            <a onClick={ () => onAcceptAlpOutboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-blue-500" }>
                                <i className="fas fa-check" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['announced'], _row.status)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reject') }>
                            <a onClick={ () => onRejectAlpOutboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-red-500" }>
                                <i className="fas fa-times" />
                            </a>
                        </Tooltip>
                    }

                    <Tooltip tooltip={ t('create cmr') }>
                        <a
                            onClick={ () => onGenerateCmrAlpOutboundLoad(_row.id) }
                            className={ "cursor-pointer ms-1 text-primary-500" }
                        >
                            <i className="fas fa-file-signature" />
                        </a>
                    </Tooltip>

                    {
                        includes(['accepted'], _row.status)
                        && ( isEmpty(_row.edited_at) && isEmpty(_row.reset_at) )
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('edit item') }>
                            <a onClick={ () => onEditAlpOutboundLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-yellow-500" }>
                                <i className="fas fa-edit" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['accepted', 'updated'], _row.status)
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('in transit') }>
                            <a onClick={ () => onInTransitAlpOutboundLoad(_row) }
                               className={ "cursor-pointer ms-1 text-green-500" }>
                                <i className="fas fa-truck-moving" />
                            </a>
                        </Tooltip>
                    }

                    {
                        includes(['in-transit'], _row.status)
                        && (
                            !isEmpty(_row.alp_supplier_compound) && !isEmpty(_row.gate_out_confirmed_at)
                        )
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('unload request') }>
                            <a onClick={ () => onUnloadRequestAlpOutboundLoad(_row) }
                               className={ "cursor-pointer text-green-500 ms-1" }>
                                <i className="fas fa-truck-loading" />
                            </a>
                        </Tooltip>
                    }

                    {
                        ( _row.type == 'AlpOutboundLoad' ) &&
                        <Tooltip tooltip={ t('update price') } position={ "left" }>
                            <a
                              className={ "cursor-pointer ms-1 text-primary-500" }
                              onClick={ () => setOutboundLoadPriceId(_row.id) }>
                                <i className="fas fa-dollar-sign" />
                            </a>
                        </Tooltip>
                    }

                    <Tooltip tooltip={ t('detail of item') }>
                        <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => {
                                openDetail(_row);
                            } }>
                            <i className="fas fa-eye" />
                        </a>
                    </Tooltip>
                </HasAccess>
            </>
        );
    };

    const AlpReexportLoadActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;

        return (
            <>
                <HasAccess hasAnyAccess={ ['alpreexportloadsupdate'] }>
                    <Tooltip tooltip={ t('sync from alp') }>
                        <a onClick={ () => onAlpReexportLoadSync(_row.id) }
                           className={ "cursor-pointer ms-1" }>
                            <i className="fas fa-sync" />
                        </a>
                    </Tooltip>
                    {
                        includes(['announced'], _row.status) &&
                        <Tooltip tooltip={ t('accept') }>
                            <a onClick={ () => onAcceptAlpReexportLoad(_row) }
                               className={ "cursor-pointer ms-1 text-blue-500" }>
                                <i className="fas fa-check" />
                            </a>
                        </Tooltip>
                    }
                    {
                        includes(['announced'], _row.status) &&
                        <Tooltip tooltip={ t('reject') }>
                            <a onClick={ () => onRejectAlpReexportLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-red-500" }>
                                <i className="fas fa-times" />
                            </a>
                        </Tooltip>
                    }
                    {
                        includes(['accepted'], _row.status)
                        && ( isEmpty(_row.edited_at) && isEmpty(_row.reset_at) )
                        &&
                        <Tooltip tooltip={ t('edit item') }>
                            <a onClick={ () => onEditAlpReexportLoad(_row.id) }
                               className={ "cursor-pointer ms-1 text-yellow-500" }>
                                <i className="fas fa-edit" />
                            </a>
                        </Tooltip>
                    }
                    {
                        includes(['accepted', 'updated'], _row.status) &&
                        <Tooltip tooltip={ t('in transit') }>
                            <a onClick={ () => onInTransitAlpReexportLoad(_row) }
                               className={ "cursor-pointer ms-1 text-green-500" }>
                                <i className="fas fa-truck-moving" />
                            </a>
                        </Tooltip>
                    }
                    {
                        includes(['in-transit'], _row.status)
                        && (
                            !isEmpty(_row.alp_supplier_compound) && !isEmpty(_row.gate_out_confirmed_at)
                        )
                        &&
                        <Tooltip tooltip={ t('unload request') }>
                            <a onClick={ () => onUnloadRequestAlpReexportLoad(_row) }
                               className={ "cursor-pointer text-green-500 ms-1" }>
                                <i className="fas fa-truck-loading" />
                            </a>
                        </Tooltip>
                    }
                </HasAccess>
                <HasAccess hasAnyAccess={ ['alpreexportloadsview'] }>
                    <Tooltip tooltip={ t('detail of item') }>
                        <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => {
                                openDetail(_row);
                            } }>
                            <i className="fas fa-eye" />
                        </a>
                    </Tooltip>
                </HasAccess>
            </>
        );
    };

    const AlpOutboundLoadGroupActionButton = (actionProps: any) => {
        const _row: any = actionProps.row;
        const isMixed = _row.status === 'mixed';
        const canInTransit = Number(_row.in_transit_eligible_count || 0) > 0;
        const canUnload = Number(_row.unload_eligible_count || 0) > 0;
        const canDestroy = Number(_row.destroy_eligible_count || 0) > 0;

        return (
            <>
                <HasAccess hasAnyAccess={ ['alpoutboundloadsupdate'] }>
                    <Tooltip tooltip={ t('sync from alp') }>
                        <a onClick={ () => onAlpOutboundLoadGroupSync(_row.id) }
                           className={ "cursor-pointer ms-1" }>
                            <i className="fas fa-sync" />
                        </a>
                    </Tooltip>

                    {
                        isMixed &&
                        <Tooltip tooltip={ t('mixed') }>
                            <span className={ "ms-1 text-red-500" }>
                                <i className="fas fa-exclamation-triangle" />
                            </span>
                        </Tooltip>
                    }

                    {
                        includes(['accepted', 'announced', 'confirmed', 'updated'], _row.status) &&
                        <Tooltip tooltip={ `${ t('add') } ${ t('load') }` }>
                            <a
                                onClick={ () => setAddLoadAlpOutboundLoadGroupId(_row.id) }
                                className={ "cursor-pointer ms-1 text-green-500" }
                            >
                                <i className="pi pi-plus" />
                            </a>
                        </Tooltip>
                    }

                    {
                      (
                        Number(_row.qty || 0) > 1 && 
                        !includes(['unload-requested'], _row.status)
                      ) &&
                        <Tooltip tooltip={ t('detach from group') }>
                            <a
                                onClick={ () => setDetachAlpOutboundLoadGroupId(_row.id) }
                                className={ "cursor-pointer ms-1 text-orange-500" }
                            >
                                <i className="fas fa-unlink" />
                            </a>
                        </Tooltip>
                    }

                    {
                        !isMixed && includes(['accepted'], _row.status) && isEmpty(_row.reset_at) && isEmpty(_row.gate_out_confirmed_at)
                        && /*@ts-ignore*/
                        <Tooltip tooltip={ t('reset') }>
                            <a onClick={ () => onResetAlpOutboundLoadGroup(_row.id) }
                               className={ "cursor-pointer ms-1 text-primary-500" }>
                                <i className="fas fa-redo-alt" />
                            </a>
                        </Tooltip>
                    }

                    {
                        !isMixed && includes(['announced'], _row.status)
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('accept') }>
                            <a onClick={ () => onAcceptAlpOutboundLoadGroup(_row.id) }
                               className={ "cursor-pointer ms-1 text-blue-500" }>
                                <i className="fas fa-check" />
                            </a>
                        </Tooltip>
                    }

                    <Tooltip tooltip={ t('create cmr') }>
                        <a
                            onClick={ () => onGenerateCmrAlpOutboundLoadGroup(_row.id) }
                            className={ "cursor-pointer ms-1 text-primary-500" }
                        >
                            <i className="fas fa-file-signature" />
                        </a>
                    </Tooltip>

                    {
                        !isMixed && includes(['accepted', 'announced', 'confirmed', 'updated'], _row.status)
                        && ( isEmpty(_row.reset_at) )
                        &&
                        /*isEmpty(_row.edited_at) && */
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('edit item') }>
                            <a onClick={ () => onEditAlpOutboundLoadGroup(_row.id) }
                               className={ "cursor-pointer ms-1 text-yellow-500" }>
                                <i className="fas fa-edit" />
                            </a>
                        </Tooltip>
                    }

                    {
                        ((!isMixed && includes(['accepted', 'updated'], _row.status))
                            || (isMixed && canInTransit))
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('in transit') }>
                            <a onClick={ () => onInTransitAlpOutboundLoadGroup(_row.id) }
                               className={ "cursor-pointer ms-1 text-green-500" }>
                                <i className="fas fa-truck-moving" />
                            </a>
                        </Tooltip>
                    }

                    {
                        ((!isMixed
                            && includes(['in-transit'], _row.status)
                            && (!isEmpty(_row.alp_supplier_compound) && !isEmpty(_row.gate_out_confirmed_at)))
                            || (isMixed && canUnload))
                        &&
                        /*@ts-ignore*/
                        <Tooltip tooltip={ t('unload request') }>
                            <a onClick={ () => onUnloadRequestAlpOutboundLoadGroup(_row.id) }
                               className={ "cursor-pointer text-green-500 ms-1" }>
                                <i className="fas fa-truck-loading" />
                            </a>
                        </Tooltip>
                    }

                    {
                        Number(_row.qty || 0) > 0 &&
                      <HasAccess hasAnyAccess={ ['alpgrouploadsdestroy'] }>
                          <Tooltip tooltip={ t('delete item') }>
                              <a
                                title={ t('delete item') }
                                className={ "cursor-pointer ms-1 text-red-500" }
                                onClick={ (event: any) => confirmPopup({
                                    target: event.currentTarget,
                                    message: t('do you want to delete this record?'),
                                    icon: 'pi pi-info-circle',
                                    // @ts-ignore
                                    defaultFocus: 'reject',
                                    acceptClassName: 'p-button-danger',
                                    accept: () => onDeleteAlpOutboundLoadGroup(_row.id),
                                    reject: () => {
                                    },
                                }) }
                              >
                                  <i className="fas fa-trash-alt" />
                              </a>
                          </Tooltip>
                      </HasAccess>
                    }

                    <Tooltip tooltip={ t('detail of item') }>
                        <a
                            className={ "cursor-pointer ms-1" }
                            onClick={ () => {
                                openDetail(_row);
                            } }>
                            <i className="fas fa-eye" />
                        </a>
                    </Tooltip>
                </HasAccess>
            </>
        );
    };

    const columns = useMemo(() => ([
        {
            field: 'load_number',
            title: t("load number"),
            sorting: true,
            sortField: "load_number",
            render: (row: any) => {
                return (
                    <>
                        <ColumnLoadNumber row={ row } t={ t } />
                        { !isEmpty(row.provider) && <div className="text-capitalize">{ row.provider }</div> }
                    </>
                );
            }
        },
        {
            field: 'driver_name',
            title: t("driver"),
            sortField: "driver_name",
            sorting: true,
            render: (row: any) => <ColumnRenderForDriver row={ row } t={ t } />
        },
        {
            field: 'cmr',
            title: t("cmr"),
            sortField: "cmr",
            sorting: true,
        },
        {
            field: 'legal_entity',
            title: t("legal entity"),
            render: (row: any) => <ColumnRenderForLegalEntity row={ row } t={ t } dropdowns={ dropdowns }/>
        },
        {
            field: 'ldg_nr',
            title: t("ldg nr"),
            sorting: false,
            render: (row: any) => <>
                <div>
                    { customSplitter(( get(row, ['ldg_nr']) || "" )
                    .split("||"))
                    .map((i: any) => i.value).join(', ') }
                </div>
            </>
        },
        {
            field: 'client',
            title: t('client'),
            sorting: false,
            render: (row: any) => <ColumnRenderForClient row={ row } t={ t } dropdowns={ dropdowns }/>
        },
        {
            field: 'dealer',
            title: t('dealer'),
            sorting: false,
            render: (row: any) => {
                if ( includes(["AlpOutboundLoad", "AlpOutboundLoadGroup", "AlpReexportLoad", "AlpSpotLoad"], row.type) ) {
                    const dealerNames: string[] = (row.alp_dealer_name || "")
                        .split("||")
                        .map((part: string) => {
                            const cleanPart = (part || "").trim();
                            if ( cleanPart === "" ) {
                                return "";
                            }

                            const [name] = split(cleanPart, "___");
                            return (name || cleanPart).trim();
                        })
                        .filter((name: string) => !isEmpty(name));
                    let uniqueDealerNames: string[] = Array.from(new Set<string>(dealerNames));

                    // Fallback: some responses already arrive as a single comma-separated string.
                    if ( uniqueDealerNames.length === 1 && uniqueDealerNames[0].includes(",") ) {
                        uniqueDealerNames = Array.from(
                            new Set<string>(
                                uniqueDealerNames[0]
                                    .split(",")
                                    .map((name: string) => name.trim())
                                    .filter((name: string) => !isEmpty(name))
                            )
                        );
                    }

                    if ( uniqueDealerNames.length <= 0 ) {
                        return <span></span>;
                    }

                    return (
                        <div>
                            { uniqueDealerNames.map((name: any, index: any) => (
                                <div key={ `${ name }-${ index }` }>
                                    { index + 1 }. { name }
                                </div>
                            )) }
                        </div>
                    );
                }

                return <span></span>;
            }
        },
        {
            field: 'brand_model',
            title: t('model(s)'),
            sorting: false,
            render: (row: any) => <ColumnRenderForBrandModel row={ row } t={ t } dropdowns={ dropdowns } />
        },
        {
            field: 'transport_vehicle',
            title: t('transport vehicle'),
            sorting: false,
            render: (row: any) => <ColumnRenderForTransportVehicle row={ row } t={ t } />
        },
        {
            field: 'locations',
            title: t('location'),
            sorting: false,
            render: (row: any) => <ColumnRenderForLocation row={ row } t={ t } dropdowns={ dropdowns } />
        },
        {
            field: 'from_location',
            title: t('from location'),
            sorting: false,
            render: (row: any) => <ColumnRenderForFromLocation row={ row } dropdowns={ dropdowns } />
        },
        {
            field: 'to_location',
            title: t('to location'),
            sorting: false,
            render: (row: any) => <ColumnRenderForToLocation row={ row } dropdowns={ dropdowns } />
        },
        {
            field: 'order_id',
            title: t('vin(s)'),
            sorting: false,
            render: (row: any) => <ColumnRenderForVin row={ row } t={ t } />
        },
        {
            field: 'emil_frey_current_list_number',
            title: t('current list number'),
            sorting: false,
            render: (row: any) => <>
                <div>
                    { customSplitter(( get(row, ['emil_frey_current_list_number']) || "" )
                    .split("||"))
                    .map((i: any) => (<div>{ i.value }</div>)) }
                </div>
            </>
        },
        {
            field: 'qty',
            title: t('qty'),
            sorting: false,
            render: (row: any) => <ColumnRenderForQty row={ row } t={ t } />
        },
        {
            field: 'status',
            title: t('status'),
            sorting: false,
            render: (row: any) => {
                return <>
                    <ColumnRenderStatus
                        row={ row }
                        t={ t }
                        onClickSpotLoadStatusUpdate={ onClickSpotLoadStatusUpdate } />
                    <div>{ !isEmpty(row.load_invoiced_at) ? t('invoiced') : '' }</div>
                </>;
            }
        },
        {
            field: 'invoiced_at',
            title: t('invoiced at'),
            sorting: false,
            render: (row: any) => <ColumnRenderInvoicedAt row={ row } t={ t } />
        },
        {
            field: 'invoice_number',
            title: t('invoice'),
            sorting: false,
            render: (row: any) => <ColumnRenderForInvoiceNumber row={ row } t={ t } />
        },
        {
            field: 'delivery_request_date',
            title: t('delivery request date'),
            sorting: false,
            render: (row: any) => {
                if ( includes(["AlpOutboundLoad", "AlpOutboundLoadGroup"], row.type) && !isEmpty(row.alp_created_at) ) {
                    return <span>{ utcDateToLocalDate(row.alp_created_at) }</span>;
                }

                return <span></span>;
            }
        },
        {
            field: 'in_transit_at',
            title: t('loading date'),
            sorting: false,
            render: (row: any) => <ColumnRenderInTransitAt row={ row } t={ t } />
        },
        {
            field: 'delivered_at',
            title: t('unloading date'),
            sorting: false,
            render: (row: any) => <ColumnRenderDeliveredAt row={ row } t={ t } />
        },
        {
            field: 'actual_loading_at',
            title: t('actual loading date'),
            sorting: false,
            render: (row: any) => <ColumnRenderActualLoadingAt row={ row } t={ t } />
        },
        {
            field: 'actual_unloading_at',
            title: t('actual unloading date'),
            sorting: false,
            render: (row: any) => <ColumnRenderActualUnloadingAt row={ row } t={ t } />
        },
        {
            field: 'comments',
            title: t('comments'),
            sorting: false,
            align: 'center',
            render: (row: any) => {
                if ( !(row.load_source_id || row.source_id || row.id) ) {
                    return null;
                }

                return (
                    <HasAccess hasAnyAccess={ ['loadcommentsview', 'loadcommentsstore'] }>
                        {/*@ts-ignore*/}
                        <Tooltip tooltip={ Number(row?.load_comments_count || 0) > 0 ? `${ t('comments') } (${ row.load_comments_count })` : t('comments') }>
                            <a onClick={ () => onOpenLoadComments(row) }
                               className={ "cursor-pointer ms-1 text-blue-500 load-comment-action" }>
                                <i className="fas fa-comments" />
                                { Number(row?.load_comments_count || 0) > 0 &&
                                  <span className="load-comment-action__count">{ row.load_comments_count }</span>
                                }
                            </a>
                        </Tooltip>
                    </HasAccess>
                );
            },
        },
        {
            field: 'action',
            title: t('action'),
            sorting: false,
            align: 'left',
            render: (_row: any) => {
                return ( <>
                    { _row.type === "AlpSpotLoad" && <AlpSpotLoadActionButton row={ _row } /> }
                    { _row.type === "AlpInboundLoad" && <AlpInboundLoadActionButton row={ _row } /> }
                    { _row.type === "AlpOutboundLoad" && <AlpOutboundLoadActionButton row={ _row } /> }
                    { _row.type === "AlpOutboundLoadGroup" && <AlpOutboundLoadGroupActionButton row={ _row } /> }
                    { _row.type === "AlpReexportLoad" && <AlpReexportLoadActionButton row={ _row } /> }
                    { _row.type === "SpotLoad" && <SpotLoadActionButton row={ _row } /> }
                </> );
            }
        },
    ]), [t, dropdowns, openDetail, goToSpotLoadModule]);

    const onReset = (reset: any = true) => {
        const mStates = { ...moduleState };

        if ( reset ) {
            mStates.filters = {
                ...getFiltersObject(mStates.filters),
                load_types: loadTypesForTab(activeTab),
            };
            mStates.page = 1;
            mStates.search = null;
        }

        mStates.tab = activeTab;
        props.setQuery(mStates);
    };

    const onSearch = ({ search }: any) => {
        props.setQuery({
            ...moduleState,
            tab: activeTab,
            search: search
        });
    };

    const onFilterClick = () => {
        setFilterPanel(true);
    };

    const onClickSpotLoadStatusUpdate = useCallback((row: any) => {
        if ( row.type === "SpotLoad" ) {
            setSpotLoadItemToBeUpdate(row);
        }
    }, []);

    const setRowClass = useCallback((row: any) => {
        const updated: any = getLastUpdate();

        if ( get(row, ['type']) === "SpotLoad" ) {
            const allLegalEntity = row.legal_entity.split("||");
            let announcedColor: any = null;
            let inTransitColor: any = null;
            let deliveredColor: any = null;

            map(allLegalEntity, (item: any) => {
                const legalEntities = item.split("___");
                if ( includes(['announced'], get(legalEntities[1].split("~~~"), ['0']))) {
                    announcedColor = get(find(dropdowns.legalEntities, { id: legalEntities[1].split("~~~")[1] }), ['color']);
                }

                if ( includes(['in-transit'], get(legalEntities[1].split("~~~"), ['0'])) ) {
                    inTransitColor = get(find(dropdowns.legalEntities, { id: legalEntities[1].split("~~~")[1] }), ['color']);
                }

                if ( includes(['delivered'], get(legalEntities[1].split("~~~"), ['0'])) ) {
                    deliveredColor = get(find(dropdowns.legalEntities, { id: legalEntities[1].split("~~~")[1] }), ['color']);
                }
            });

            return css`
                background-color: ${(announcedColor !== null ? announcedColor : (inTransitColor !== null ? inTransitColor : deliveredColor))};
                
                & > td:first-child {
                    border-left: ${get(updated, ['id']) === row.id ? '2px solid blue' : '2px solid transparent'}
                }
            `;
        }

        if ( get(row, ['type']) === "AlpSpotLoad" ) {
            const fromLocation = find(dropdowns.legalEntities, { id: get(row, ['legal_entity']) });
            const color = get(fromLocation, ['color']);

            return css`
                background-color: ${color};
                
                & > td:first-child {
                    border-left: ${get(updated, ['id']) === row.id ? '2px solid blue' : '2px solid transparent'}
                }
            `;
        }

        return {};
    }, [dropdowns]);

    const onOperationClick = (operationToBePerformed: any = 'add', id: any = null) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('operation', operationToBePerformed);
        searchParams.set('operationId', id);

        if ( isEmpty(operationToBePerformed) ) {
            searchParams.delete('operation');
        }

        if ( isEmpty(id) ) {
            searchParams.delete('operationId');
        }

        navigate({
            pathname: location.pathname,
            search: searchParams.toString(),
        }, { replace: true });
        setOperationId(id);
        setOperation(operationToBePerformed);
    };

    const onCloseOperation = (reset: any = true) => {
        const sp = new URLSearchParams(location.search);
        sp.delete('operation');
        sp.delete('operationId');
        sp.delete(DETAIL_TYPE_PARAM);
        sp.delete(DETAIL_LOAD_NUMBER_PARAM);

        navigate({
            pathname: location.pathname,
            search: sp.toString(),
        }, { replace: true });

        setOperation(null);
        setOperationId(null);
        setDetailLoadType(null);
        setDetailLoadNumber(null);
        onReset(reset);
    };

    const refreshTable = () => {
        if ( tableRef.current ) {
            tableRef.current.onRefresh();
        }
    };

    const focusOnSearch = () => {
        const searchInput: HTMLInputElement | null = document.querySelector('input[name="search"]');
        if ( searchInput ) {
            searchInput.focus();
        }
    };

    const onExcelClick = () => {
        setExcelPanel(true);
    };

    const setTabInUrl = (nextTab: any) => {
        const nextSearchParams = new URLSearchParams(location.search);
        nextSearchParams.set(TAB_PARAM, nextTab);

        navigate({
            pathname: location.pathname,
            search: nextSearchParams.toString(),
        }, { replace: true });
    };

    const syncTabToQuery = (nextTab: any) => {
        const baseFilters = getFiltersObject(moduleState?.filters);

        props.setQuery({
            ...moduleState,
            tab: nextTab,
            page: 1,
            filters: {
                ...baseFilters,
                load_types: loadTypesForTab(nextTab),
            }
        });
    };

    // URL should always have ?tab=inbound|outbound|reexport (matches selected tab + grid filters)
    useEffect(() => {
        const urlTab = searchParams.get(TAB_PARAM);
        const resolvedTab = parseTab(urlTab || moduleState.tab);

        if ( urlTab !== resolvedTab ) {
            setTabInUrl(resolvedTab);
            return;
        }

        const expectedLoadType = loadTypesForTab(resolvedTab)[0];
        const currentLoadTypes = get(getFiltersObject(moduleState?.filters), ['load_types']);
        const currentLoadType = Array.isArray(currentLoadTypes) ? currentLoadTypes[0] : null;

        if ( currentLoadType !== expectedLoadType ) {
            syncTabToQuery(resolvedTab);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, moduleState?.tab]);

    // Keep detail type in sync when page is refreshed on a detail URL
    useEffect(() => {
        setOperation(searchParams.get('operation'));
        setOperationId(searchParams.get('operationId'));
        setDetailLoadType(searchParams.get(DETAIL_TYPE_PARAM));
        setDetailLoadNumber(searchParams.get(DETAIL_LOAD_NUMBER_PARAM));
    }, [location.search]);

    const renderGrid = () => {
        return (
            <StateLessGrid
                size={ "normal" }
                url={ '/suppliers/loads?1=1' }
                name={ "loadList" }
                columns={ columns }
                moduleState={ moduleState }
                setQuery={ props.setQuery }
                setRowClass={ setRowClass }
                ref={ tableRef }
                setTotal={ setTotal }
                stickyHeader={ true }
                showQuickCopy={ false }
                showLoader={ true }
                loaderLabel={ t('loading') }
                onRowSelection={ setSelectedRows }
                selectedRows={ selectedRows }
            />
        );
    };

    return (
        <div className={ "block-viewer" }>
            <div className={ ` block-section` }>
                <div className="block-header">
                    <span className="block-title">
                        <h5 className={ "mb-0" }>
                            <span onClick={ handleHeaderClick }>
                                {
                                    operation === 'detail' && detailLoadType
                                        ? getDetailPageTitle(detailLoadType, detailLoadNumber, t)
                                        : t('loads') + ' (' + total + ')'
                                }
                            </span>
                        </h5>
                    </span>
                    <div className="block-actions">
                        {
                            operation === 'detail' &&
                            <div>
                                <Button type={ "button" }
                                        tooltip={ t("operation cancel") } className={ "ms-2" }
                                        size={ "small" } severity={ "warning" }
                                        tooltipOptions={ { position: 'top' } }
                                        onClick={ () => onCloseOperation(false) }>
                                    <i className="pi pi-arrow-left me-2" /> { t("cancel") }
                                </Button>
                            </div>
                        }
                        <AlpFreezeStatusNotice />
                    </div>
                </div>
                <div className="block-content">
                    {
                        operation !== 'detail' &&
                        <>
                    <Row className={ `p-2` }>
                        <Col
                            sm={ 12 } md={ 6 } className={ "mb-2" }>
                            <Formik
                                enableReinitialize={ true }
                                initialValues={ { search: moduleState.search ?? null } }
                                onSubmit={ onSearch }
                            >
                                { (props: FormikProps<any>) => {
                                    return (
                                        <Form onSubmit={ props.handleSubmit }>
                                            <Col sm={ 12 } md={ 8 }>
                                                <Field component={ InputField } withoutLabel={ true }
                                                       autoFocus={true}
                                                       name="search"
                                                       formGroupClass={ "mb-0" }
                                                       placeholder={ t("search") } />
                                            </Col>
                                        </Form>
                                    );
                                } }
                            </Formik>
                        </Col>

                        <Col
                            sm={ 12 } md={ 6 } className={ "text-right mb-2" }>
                                <div className="d-inline-block me-2 align-middle text-left">
                                    <QuickCopyDropdown
                                        columns={ columns }
                                        tableName={ "loadList" }
                                        selectedRows={ selectedRows }
                                        trackBy={ "id" }
                                        defaultColumnFields={ ['order_id', 'vin_number', 'vin'] }
                                        // @ts-ignore
                                        entities={ tableRef.current?.getEntities?.() || [] }
                                    />
                                </div>
                                <ButtonGroup>
                                    {
                                        ( visibleSpecialAction && !disableSpecialActionInbound ) &&
                                        <Button onClick={ onAlpInboundLoadSyncList } icon="pi pi-sync" size={ "small" }
                                                outlined disabled={syncOnInbound}
                                                severity={ "danger" }
                                                label={" I "}
                                                tooltip={ t("sync") + ' ' + t("alp") + ' ' + t("inbound load") }
                                                tooltipOptions={ { position: 'top' } } />
                                    }
                                    {
                                        ( visibleSpecialAction && !disableSpecialActionOutbound ) &&
                                        <Button onClick={ onAlpOutboundLoadSyncList } icon="pi pi-sync" size={ "small" }
                                                outlined disabled={syncOnOutbound}
                                                severity={ "danger" }
                                                label={" O "}
                                                tooltip={ t("sync") + ' ' + t("alp") + ' ' + t("outbound load") }
                                                tooltipOptions={ { position: 'top' } } />
                                    }
                                    {
                                        ( visibleSpecialAction && !disableSpecialActionReexport ) &&
                                        <Button onClick={ onAlpReexportLoadSyncList } icon="pi pi-sync" size={ "small" }
                                                outlined disabled={ syncOnReexport }
                                                severity={ "danger" }
                                                label={ " R " }
                                                tooltip={ t("sync") + ' ' + t("alp") + ' ' + t("self pickup load") }
                                                tooltipOptions={ { position: 'top' } } />
                                    }
                                    {
                                        ( visibleSpecialAction && !disableSpecialActionSpot ) &&
                                        <Button onClick={ onAlpSpotLoadSyncList } icon="pi pi-sync" size={ "small" }
                                                outlined disabled={syncOnSpot}
                                                severity={ "danger" }
                                                label={" S "}
                                                tooltip={ t("sync") + ' ' + t("alp") + ' ' + t("spot load") }
                                                tooltipOptions={ { position: 'top' } } />
                                    }
                                    <Button size={ "small" } outlined tooltip={ t('add item') }
                                            tooltipOptions={ { position: 'top' } }
                                            onClick={ () => {
                                                goToSpotLoadModule(`/spot/loads?back_to=loads&operation=add`);
                                            } }>
                                        <i className="pi pi-plus" />
                                        <span className={ "ms-1" }>{ t('add') }</span>
                                    </Button>
                                    <Button size={ "small" } outlined tooltip={ t('generate bulk invoice(s)') }
                                            tooltipOptions={ { position: 'top' } }
                                            onClick={ () => setBulkInvoiceVisibility(true) }>
                                        <i className="pi pi-file-plus" />
                                        <span className={ "ms-1" }>{ t('bulk invoices') }</span>
                                    </Button>
                                    <Button icon="pi pi-filter-fill" size={ "small" } outlined tooltip={ t('filter') }
                                            onClick={ onFilterClick }
                                            tooltipOptions={ { position: 'top' } } />
                                    <Button icon="pi pi-file-excel" size={ "small" } outlined tooltip={ t('excel') }
                                            onClick={ onExcelClick }
                                            tooltipOptions={ { position: 'top' } } />
                                    <Button onClick={ onReset } icon="pi pi-refresh" size={ "small" } outlined
                                            tooltip={ t('reset') }
                                            tooltipOptions={ { position: 'top' } } />
                                </ButtonGroup>
                        </Col>
                    </Row>

                    <Row className={ `px-2 pb-2` }>
                        <Col sm={ 12 }>
                            <TabView
                                activeIndex={ activeIndex }
                                renderActiveOnly={ true }
                                onTabChange={ (e: any) => {
                                    const nextTab = e.index === 1 ? 'outbound' : (e.index === 2 ? 'reexport' : 'inbound');
                                    setTabInUrl(nextTab);
                                    syncTabToQuery(nextTab);
                                } }
                            >
                                <TabPanel header={ t("inbound load") } />
                                <TabPanel header={ t("outbound load") } />
                                <TabPanel header={ t("self pickup load") } />
                            </TabView>
                        </Col>
                        <Col sm={ 12 }>
                            { renderGrid() }
                        </Col>
                    </Row>
                        </>
                    }

                    {
                        ( operation === 'detail' && !isEmpty(operationId) && !isEmpty(detailLoadType) ) &&
                        <LoadListDetailPanel
                            loadType={ detailLoadType }
                            operation={ operation }
                            operationId={ operationId }
                            toastify={ toastify }
                            dropdowns={ dropdowns }
                            setQuery={ props.setQuery }
                            onClose={ () => onCloseOperation(false) }
                        />
                    }

                    <SpotLoadStatusUpdate
                        toastify={ props.toastify }
                        item={ spotLoadItemToBeUpdate }
                        onClose={ () => {
                            setSpotLoadItemToBeUpdate(null);
                            refreshTable();
                            focusOnSearch();
                        } }
                    />

                    {/* ALP SPOT LOAD Components */ }
                    <AlpSpotLoadAccept
                        id={ acceptAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setAcceptAlpSpotLoadId(null);
                            focusOnSearch();
                        } } />

                    <LoadComments
                        id={ commentLoad ? (commentLoad.load_source_id || commentLoad.source_id || commentLoad.id) : null }
                        load={ commentLoad }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        onClose={ () => {
                            setCommentLoad(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadReject
                        id={ rejectAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setRejectAlpSpotLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadUpdate
                        id={ editAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setEditAlpSpotLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadReset
                        id={ resetAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setResetAlpSpotLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadInTransit
                        id={ inTransitAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setInTransitAlpSpotLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadUnloadRequest
                        id={ unloadRequestAlpSpotLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setUnloadRequestAlpSpotLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpSpotLoadUpdatePrice
                        toastify={ toastify }
                        dropdowns={ [] }
                        id={ loadId }
                        onClose={ () => {
                            setLoadId(null);
                            onReset();
                            focusOnSearch();
                        } }
                    />

                    <LoadFilter
                        moduleState={ moduleState }
                        setQuery={ props.setQuery }
                        toastify={ props.toastify }
                        dropdowns={ props.dropdowns }
                        fixedLoadTypes={ loadTypesForTab(activeTab) }
                        visibility={ filterPanel }
                        onClose={ () => {
                            setFilterPanel(false);
                            focusOnSearch();
                        } }
                    />

                    <LoadExcel
                        moduleState={ moduleState }
                        setQuery={ props.setQuery }
                        toastify={ props.toastify }
                        dropdowns={ props.dropdowns }
                        visibility={ excelPanel }
                        onClose={ () => {
                            setExcelPanel(false);
                            focusOnSearch();
                        } }
                    />

                    <ShowInvoiceableLoad
                        toastify={ toastify }
                        dropdowns={ {clients: dropdowns.clients} }
                        load={ invoiceableLoad }
                        onClose={ () => {
                            setInvoiceableLoad(null);
                            setBulkInvoiceVisibility(false);
                        } }
                    />

                    <AllInvoiceableList
                        visibility={ bulkInvoiceVisibility }
                        toastify={ toastify }
                        onClose={ () => {
                            setBulkInvoiceVisibility(false);
                        } }
                    />

                    <LoadPrePayment
                        dropdowns={ props.dropdowns }
                        visibility={ paymentVisibility }
                        toastify={ toastify }
                        onClose={ () => {
                            setPaymentVisibility({});
                        } }
                    />

                    {/* ALP Inbound Load Components */ }
                    <AlpInboundLoadAccept
                        id={ acceptAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setAcceptAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadReject
                        id={ rejectAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setRejectAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadReset
                        id={ resetAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setResetAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadTransportOrder
                        id={ confirmTransportOrderAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setConfirmTransportOrderAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadUpdate
                        id={ editAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setEditAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadInTransit
                        id={ inTransitAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ inboundLoadProviderSlug }
                        onClose={ () => {
                            setInTransitAlpInboundLoadId(null);
                            setInboundLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadUnloadRequest
                        id={ unloadRequestAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ inboundLoadProviderSlug }
                        onClose={ () => {
                            setUnloadRequestAlpInboundLoadId(null);
                            setInboundLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadConfirmTransportOrder
                        id={ confirmAfterApprovedTransportOrderAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            onConfirmAfterApprovedTransportOrderAlpInboundLoad(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadCCConfirmTransportOrder
                        id={ ccConfirmTransportOrderAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            onCcConfirmTransportOrderAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadCCDeclineTransportOrder
                        id={ ccDeclineTransportOrderAlpInboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            onCcDeclineTransportOrderAlpInboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpInboundLoadUpdatePrice
                        toastify={ toastify }
                        dropdowns={ [] }
                        id={ inboundLoadPriceId }
                        onClose={ () => {
                            setInboundLoadPriceId(null);
                            onReset();
                            focusOnSearch();
                        } }
                    />

                    <AlpOutboundLoadGroupGenerateCmr
                        id={ generateCmrAlpInboundLoadId }
                        mode="inbound"
                        toastify={ props.toastify }
                        onClose={ () => {
                            setGenerateCmrAlpInboundLoadId(null);
                            focusOnSearch();
                        } }
                    />

                    {/* ALP Outbound Load Components */ }
                    <AlpOutboundLoadAccept
                        id={ acceptAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setAcceptAlpOutboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadReject
                        id={ rejectAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setRejectAlpOutboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadReset
                        id={ resetAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setResetAlpOutboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadInTransit
                        id={ inTransitAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setInTransitAlpOutboundLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadUpdate
                        id={ editAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setEditAlpOutboundLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadUnloadRequest
                        id={ unloadRequestAlpOutboundLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setUnloadRequestAlpOutboundLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadUpdatePrice
                        toastify={ toastify }
                        dropdowns={ [] }
                        id={ outboundLoadPriceId }
                        onClose={ () => {
                            setOutboundLoadPriceId(null);
                            onReset();
                            focusOnSearch();
                        } }
                    />

                    <AlpOutboundLoadGroupGenerateCmr
                        id={ generateCmrAlpOutboundLoadId }
                        mode="load"
                        toastify={ props.toastify }
                        onClose={ () => {
                            setGenerateCmrAlpOutboundLoadId(null);
                            focusOnSearch();
                        } }
                    />

                    <AlpReexportLoadAccept
                        id={ acceptAlpReexportLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setAcceptAlpReexportLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpReexportLoadReject
                        id={ rejectAlpReexportLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setRejectAlpReexportLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpReexportLoadUpdate
                        id={ editAlpReexportLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setEditAlpReexportLoadId(null);
                            focusOnSearch();
                        } } />

                    <AlpReexportLoadInTransit
                        id={ inTransitAlpReexportLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setInTransitAlpReexportLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    <AlpReexportLoadUnloadRequest
                        id={ unloadRequestAlpReexportLoadId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        providerUploadSlug={ alpLoadProviderSlug }
                        onClose={ () => {
                            setUnloadRequestAlpReexportLoadId(null);
                            setAlpLoadProviderSlug(null);
                            focusOnSearch();
                        } } />

                    {/* ALP Outbound Load Group Components */ }
                    <AlpOutboundLoadGroupAccept
                        id={ acceptAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setAcceptAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadGroupReset
                        id={ resetAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setResetAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadGroupInTransit
                        id={ inTransitAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setInTransitAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadGroupUpdate
                        id={ editAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setEditAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadGroupUnloadRequest
                        id={ unloadRequestAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        dropdowns={ props.dropdowns }
                        onClose={ () => {
                            setUnloadRequestAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } } />

                    <AlpOutboundLoadGroupAddLoad
                        id={ addLoadAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        onClose={ () => {
                            setAddLoadAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } }
                    />

                    <AlpOutboundLoadGroupDetach
                        id={ detachAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onRefresh={ refreshTable }
                        onClose={ () => {
                            setDetachAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } }
                    />

                    <AlpOutboundLoadGroupGenerateCmr
                        id={ generateCmrAlpOutboundLoadGroupId }
                        toastify={ props.toastify }
                        onClose={ () => {
                            setGenerateCmrAlpOutboundLoadGroupId(null);
                            focusOnSearch();
                        } }
                    />

                    <ConfirmPopup />
                </div>
            </div>
        </div>
    );
};

LoadList.propTypes = {
    // t: PropTypes.any,
};

export default withTranslation()(WithRouter(LoadList));
